import React from 'react'

/**
 * Story 175 -- one block of the machine detail drawer, headed like the groups of the job detail panel:
 * a green uppercase title (the casing is CSS only, the text stays the translated literal) and an
 * optional caption on the right.
 */
const MachineDetailSection = ({ testId, title, caption, captionTestId, children }) => (
  <section className='mdd__group' data-testid={testId}>
    <div className='mdd__group-head'>
      <h3 className='mdd__group-title'>{title}</h3>
      {caption ? <span className='mdd__group-caption' data-testid={captionTestId}>{caption}</span> : null}
    </div>
    {children}
  </section>
)

export default MachineDetailSection
